<template>
  <section class="product-bar">
    <div class="product-bar">
      <transition-group name="slide-up">
        <product-item-card
          v-for="(productCard, i) in productCards"
          v-if="showProductCard"
          :key="productCard.name.split(' ').join('-') + i"
          :productCard="productCard"
        />
      </transition-group>
      <transition name="fade">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1000 20"
          class="product-bar__bar"
          preserveAspectRatio="none"
          width="100%"
          height="100%"
        >
          <polygon points="0,0  1000,0  1000,20 0,20" style="fill:black;" />
        </svg>
        <!-- v-if="productMotion" -->
      </transition>
    </div>
    <product-item />
  </section>
</template>

<script>
import ProductItem from "@/components/ProductItem";
import ProductItemCard from "@/components/ProductItemCard";
import { mapState } from "vuex";
export default {
  name: "product-bar",
  components: { ProductItem, ProductItemCard },
  computed: {
    ...mapState({
      productCards: state => state.productBar.productCards,
      showProductCard: state => state.productBar.showProductCard,
      productMotion: state => state.productBar.productMotion
    })
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";
.product-bar {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 1.5vw;
  @media screen and (max-aspect-ratio: 256/135) {
    height: 3.5vw;
  }
  &__bar {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
$transition-duration: 1s;
.slide-up-enter-active {
  transition: transform $transition-duration cubic-bezier(0.22, 1, 0.36, 1),
    opacity $transition-duration cubic-bezier(0.22, 1, 0.36, 1);
  opacity: 1;
}
.slide-up-enter {
  transform: translateY(17.5vw);
  opacity: 0;
}
.slide-up-leave-active {
  transition: transform $transition-duration + 1 cubic-bezier(0.22, 1, 0.36, 1),
    opacity $transition-duration / 2 cubic-bezier(0.22, 1, 0.36, 1);
  opacity: 0;
}
.slide-up-leave-to {
  transform: translateY(17.5vw);
}
.fade-enter-active {
  transition: opacity $button-duration ease-in-out;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-active {
  transition: opacity 0s ease-in-out;
}
.fade-leave-to {
  opacity: 0;
}
</style>
